import { supabase } from "@/integrations/supabase/client";
import { toast } from "@/hooks/use-toast";

interface NewCompany {
	name: string;
	assignee?: string;
	street?: string;
	postal_code?: string;
	city?: string;
	country?: string;
	vat_number?: string;
	website_url?: string;
	logo_url?: string;
}

export const useAddCompany = () => {
	const addCompany = async (newCompany: NewCompany): Promise<boolean> => {
		try {
			const { data: userOrgData } = await supabase.auth.getSession();
			const userUuid = userOrgData.session?.user?.id;

			let organizationUuid = null;
			if (userUuid) {
				const { data: userOrg } = await supabase
					.from('user_organization')
					.select('organization_uuid')
					.eq('user_uuid', userUuid)
					.single();
				organizationUuid = userOrg?.organization_uuid;
			}

			const { data, error } = await supabase
				.from('companies')
				.insert([{
					name: newCompany.name,
					street: newCompany.street,
					postal_code: newCompany.postal_code,
					city: newCompany.city,
					country: newCompany.country || "Belgium",
					assignee: newCompany.assignee,
					vat_number: newCompany.vat_number,
					website_url: newCompany.website_url,
					logo_url: newCompany.logo_url,
					is_dummy_data: false,
					organization_uuid: organizationUuid,
				}])
				.select();

			if (error)
				throw error;

			if (data && data.length > 0) {
				toast({
					title: "Company added",
					description: `${newCompany.name} has been added successfully.`,
				});
				return true;
			}

			return false;
		} catch (error) {
			console.error("Error adding company:", error);
			toast({
				title: "Failed to add company",
				description: "There was an error adding the company. Please try again.",
				variant: "destructive",
			});
			return false;
		}
	};

	return { addCompany };
};
